module.exports = __webpack_public_path__ + "img/feat_mount.d26cdec3.png";